import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Switch,
} from "@mui/material";
import utilStyle from "./Utils.module.css";
import pageStyle from "./CustomerDetails.module.css";
import { Delete, Save } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  APIProduct,
  deleteProduct,
  emptyProduct,
  getProduct,
  saveProduct,
} from "../api/products";

function ProductDetailsPage({ id }: { id?: string }) {
  const navigate = useNavigate();

  const [product, setProduct] = useState<APIProduct>(emptyProduct());
  useEffect(() => {
    getProduct(id || undefined).then((v) => setProduct(v));
  }, [id]);

  // Handle changes
  const changeProduct = (change: Partial<APIProduct>) => {
    const update = { ...product, ...change };
    setProduct(update);
    handleSave(update);
  };

  const handleSave = async (updatedProduct: APIProduct) => {
    const p = await saveProduct(updatedProduct);
    if (!updatedProduct.id) {
      navigate(`/products?id=${p.id}`);
    }
  };

  const handleDelete = async () => {
    if (id) {
      await deleteProduct(id);
    }
    navigate("/products");
  };

  return (
    <div className={pageStyle.customerDetailPanel}>
      <div>
        <form
          className={pageStyle.editCustomerForm}
          noValidate
          autoComplete="off"
        >
          <FormControl>
            <InputLabel htmlFor="titleInput">Title</InputLabel>
            <OutlinedInput
              value={product.title}
              onChange={(e) => changeProduct({ title: e.target.value })}
              id="titleInput"
              label="Title"
            />
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="descriptionInput">Description</InputLabel>
            <OutlinedInput
              value={product.description}
              onChange={(e) => changeProduct({ description: e.target.value })}
              multiline
              minRows={3}
              id="descriptionInput"
              label="Description"
            />
          </FormControl>
          <FormControl>
            <InputLabel>Price</InputLabel>
            <OutlinedInput
              type="number"
              value={product.price}
              onChange={(e) => changeProduct({ price: Number(e.target.value) })}
              label="Price"
              startAdornment={
                <InputAdornment position="start">$</InputAdornment>
              }
            />
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={product.taxable}
                onChange={(e) => changeProduct({ taxable: e.target.checked })}
              />
            }
            label="Taxable"
          />
        </form>
        <div className={utilStyle.controlHeader}>
          <div className={utilStyle.controlHeaderButtonContainer}>
            <Button
              color="error"
              variant="outlined"
              startIcon={<Delete />}
              disabled={!id}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetailsPage;
